import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog } from '@angular/material';
import { AppStorage } from '../../shared/services/appStorage.service';
import { Router } from '@angular/router';
import { ApiUsuariosService } from 'src/app/shared/services/api-usuarios.service';

@Component({
  selector: 'app-coordinados-usuarios',
  templateUrl: './coordinados-usuarios.component.html',
  styleUrls: ['./coordinados-usuarios.component.css']
})
export class CoordinadosUsuariosComponent implements OnInit {
  displayedColumns: string[] = ['nombre', 'email'];
  dataSource;
  empresa;
  loadingUsuarios;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    public appStorage: AppStorage,
    private apiUsuariosService: ApiUsuariosService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    if (
      this.appStorage.datosSesion.perfil !==
      this.appStorage.perfilesUsuario.COORDINADOR_ADMINISTRADOR
    ) {
      this.appStorage.goHome();
    } else {
      if (this.appStorage.empresa) {
        this.empresa = this.appStorage.empresa;
        this.cargarUsuarios();
      } else {
        this.router.navigate(['/admin/coordinados']);
      }
    }
  }

  cargarUsuarios() {
    this.loadingUsuarios = true;
    this.apiUsuariosService
      .getUsuariosEmpresa(this.empresa.idEmpresa)
      .then((res: any) => {
        this.dataSource = new MatTableDataSource(res);
        this.loadingUsuarios = false;

        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.paginator.itemsPerPageLabel = 'Usuarios por página';
        }, 200);
      })
      .catch(error => {
        this.loadingUsuarios = false;
      });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  volver() {
    this.location.back();
  }
}
